<style scoped>
#grid {
  display: grid;
  grid-template-areas:
      "stats-info"
      "bar-chart"
      "line-chart";
  grid-template-columns:1fr;
  grid-gap: 15px;
}

#StatsInfo {
  grid-area: stats-info;
}
#PNLByDayBarChart {
  grid-area: bar-chart;
}
#TotalPNLByDayChart {
  grid-area: line-chart;
}

</style>

<template>
  <div id="grid">
    <StatsInfo id="StatsInfo"/>
    <PNLByDayBarChart id="PNLByDayBarChart"/>
    <TotalPNLByDayChart id="TotalPNLByDayChart"/>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import PNLByDayBarChart from '@/components/MainPage/Stats/PNLByDayBarChart.vue'
import TotalPNLByDayChart from '@/components/MainPage/Stats/TotalPNLByDayLineChart.vue'
import StatsInfo from '@/components/MainPage/Stats/StatsInfo.vue'
import stats from '@/services/stats'
import { StatsData } from '@/util/types'

@Component({
  components: {
    TotalPNLByDayChart,
    PNLByDayBarChart,
    StatsInfo
  }
})
export default class Stats extends Vue {
  get statsdata () {
    // @ts-ignore
    return (this.$store.state.stats as StatsData)
  }

  @Watch('$route')
  routeChanged (to: any, from: any) {
    // console.log(to)
    if (to.name === 'stats') {
      stats.updateStats()
    }
  }

  @Watch('$store.state.statsdata.Dates')
  datesChanged (d1: Date[], d2: Date[]) {
    if (d1[0].getTime() === d2[0].getTime() && d1[1].getTime() === d2[1].getTime()) {
      // console.log('ignored')
      return
    }
    // console.log('changed:', JSON.stringify(d1), JSON.stringify(d2))
    // @ts-ignore
    // console.log('dates', this.$store.state.statsdata.Dates)
    stats.updateStats()
  }

  @Watch('$store.state.statsdata.td')
  tradeStatTypeChanged () {
    stats.updateStats()
  }

  @Watch('$store.state.statsdata.bt')
  botStatTypeChanged () {
    stats.updateStats()
  }

  @Watch('$store.state.statsdata.br')
  boosterStatTypeChanged () {
    stats.updateStats()
  }

  @Watch('$store.state.sys.tradeExchange.Id')
  exchChanged () {
    stats.updateStats()
  }

  @Watch('$store.state.sys.demo')
  demoChanged () {
    stats.updateStats()
  }

  created () {
    stats.updateStats()
  }
}
</script>
